export interface NotificationParentDetails {
  parentId: number;
  parentEntity: string;
}

export interface NotificationReceiver {
  id: number;
  receiverId: number;
  notificationId: number;
  isRead: boolean;
}

export class Notification {
  id: number;
  title: string;
  content: string;
  event: EventsEnum;
  createdAt: Date;
  parentDetails?: NotificationParentDetails;
  currentUserReceiver?: NotificationReceiver | null;
}

export enum EventsEnum {
  PUBLIC_NOTIFICATION = 'public.notification',

  NEWS_ALARM = 'news.alarm',

  VISA_REQUEST_ASSIGNED_TO_EMPLOYEE = 'visa.request.assigned.to.employee',
  VISA_REQUEST_APPOINTMENT_SET = 'visa.request.appointment.set',
  VISA_REQUEST_DS_160_STATUS_PENDING_APPROVAL = 'visa.request.ds.160.status.pending.approval',
  VISA_REQUEST_DS_160_STATUS_CONFIRMED = 'visa.request.ds.160.status.confirmed',
  VISA_REQUEST_FINAL_DETAILS_SET = 'visa.request.final.details.set',
  VISA_REQUEST_APPOINTMENT_WITHIN_48_HOURS = 'visa.request.appointment.within.48.hours',
  PASSPORT_EXPIRY_DATE = 'passport.expiry.date',
  VISA_EXPIRY_DATE = 'visa.expiry.date',

  HAPPY_BIRTHDAY = 'happy.birthday',

  PAYMENT_REQUIRED = 'payment.required',
  NO_REPLY = 'no.reply',
  DOCUMENTS_REQUIRED = 'documents.required',
  BUG_REPORT_FIXED = 'bug.report.fixed',
  LEAVE_REQUEST_CREATED = 'leave.request.created',
  LEAVE_REQUEST_DECIDED = 'leave.request.decided',

  TASK_ASSIGNED_TO_EMPLOYEE = 'task.assigned.to.employee',
  REFUND_REQUEST_PENDING_APPROVAL = 'refund.request.pending.approval',
  REFUND_ACCEPTED_NOTIFY_INITIATOR = 'refund.accepted.notify.initiator',
  VISA_REQUEST_APPROVED_FOR_EMPLOYEE = 'visa.request.approved.for.employee',
  REFUND_PAID_FOR_EMPLOYEE = 'refund.paid.for.employee',
  VISA_REQUEST_REVIEW_READY = 'visa.request.review.ready',
  VISA_REQUEST_REVIEW_ASPECT_REJECTED = 'visa.request.review.aspect.rejected',

  CLIENT_PORTAL_CONFIRMATION_SUBMITTED = 'client.portal.confirmation.submitted',
  APPLICATION_REVIEW_RESPONDED = 'application.review.responded',
  EMBASSY_EMAIL_RECEIVED = 'embassy.email.received',

  STAFF_WEEKLY_REMINDER = 'staff.weekly.reminder'
}

export enum ApplyingFrom {
  EG = 'EG',
  SA = 'SA',
  UK = 'UK',
  AE = 'AE',
  KW = 'KW',
  OM = 'OM',
  BH = 'BH',
  TN = 'TN',
  MA = 'MA',
  QA = 'QA',
  IQ = 'IQ',
  JO = 'JO',
  DZ = 'DZ'
}

export enum ApplyingFromEmbassyByCode {
  EG = 'Egypt',
  SA = 'Saudi Arabia',
  UK = 'UK',
  AE = 'UAE',
  KW = 'Kuwait',
  OM = 'Oman',
  BH = 'Bahrain',
  TN = 'Tunisia',
  MA = 'Morocco',
  QA = 'Qatar',
  IQ = 'Iraq',
  JO = 'Jordan',
  DZ = 'Algeria'
}

export enum ApplyingFromEmbassyByName {
  'Egypt' = 'EG',
  'Saudi Arabia' = 'SA',
  'UK' = 'UK',
  'UAE' = 'AE',
  'Kuwait' = 'KW',
  'Oman' = 'OM',
  'Bahrain' = 'BH',
  'Tunisia' = 'TN',
  'Morocco' = 'MA',
  'Qatar' = 'QA',
  'Iraq' = 'IQ',
  'Jordan' = 'JO',
  'Algeria' = 'DZ'
}

export enum RequestOwnerNotificationType {
  PASSPORT_UPDATES = 'passport.updates',
  PASSPORT_READY = 'passport.ready',
  APPOINTMENT_UPDATES = 'appointment.updates',
  APPOINTMENT_REMINDER = 'appointment.reminder'
}
